/**
 * P2 — formatação (só unidade/apresentação) dos valores de elegibilidade que o servidor devolve.
 * Nada aqui decide elegibilidade.
 */
import { ROTULO_TIPO_ELEGIBILIDADE, TipoElegibilidade } from '@/types/elegibilidade'
import { pctDeFracao } from '@/pages/simulacao/fracao'

/** `2026-10-25` → `25/10/2026` sem passar por Date (sem fuso); date-time ISO usa só a data. */
export const formatarDataIso = (iso: string | null | undefined): string => {
  if (!iso) return '—'
  const [a, m, d] = iso.slice(0, 10).split('-')
  return d && m && a ? `${d}/${m}/${a}` : iso
}

/** Fração (0,5) → "50%" — mesma borda da tela de Simulações. */
export const fracaoComoPercentual = (fracao: number | null | undefined): string => pctDeFracao(fracao)

/** "Política v2 · Faturamento mínimo · vigente desde 25/10/2026". */
export const textoPolitica = (p: {
  politicaVersao?: number | null
  politicaTipo?: TipoElegibilidade | null
  politicaVigenciaInicio?: string | null
}): string | null => {
  if (p.politicaVersao == null && !p.politicaTipo) return null
  return [
    p.politicaVersao != null ? `Política v${p.politicaVersao}` : 'Política',
    p.politicaTipo ? ROTULO_TIPO_ELEGIBILIDADE[p.politicaTipo] ?? p.politicaTipo : null,
    p.politicaVigenciaInicio ? `vigente desde ${formatarDataIso(p.politicaVigenciaInicio)}` : null,
  ]
    .filter(Boolean)
    .join(' · ')
}
